import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { HttpBackendService } from 'src/app/core/backend-services/http/http.backend-service';

export interface RoundAnalysisResponse {
  success: boolean;
  data: {
    improvements: string[];
    positives: string[];
  };
}

export interface AdminAnalysisResponse {
  message: string;
  availablePlayers: Array<{
    userID: number;
    username: string;
  }>;
}

export interface Player {
  userID: number;
  username: string;
}

@Injectable({
  providedIn: 'root',
})
export class RoundAnalysisBackendService {
  private readonly BASE_ADDRESS = '/game/round';

  constructor(private http: HttpBackendService) {}

  public getRoundAnalysis(roundId: string, forUserId?: number): Promise<RoundAnalysisResponse | AdminAnalysisResponse> {
    const url = forUserId 
      ? `${this.BASE_ADDRESS}/${roundId}/analysis?forUserId=${forUserId}`
      : `${this.BASE_ADDRESS}/${roundId}/analysis`;
      
    return firstValueFrom(
      this.http.get<RoundAnalysisResponse | AdminAnalysisResponse>(url)
    );
  }
}